export const CustomizedDot = () => {
  return null;
};
